import { useState } from "react";

interface useConfirmationProps{
    initialValue: boolean
}

export const useConfirmation = ({initialValue = false}: useConfirmationProps) => {

    const [confirmation, setConfirmation] = useState<boolean>(initialValue);

    const confirmated = () => setConfirmation(true);

    const notConfirmated = () => setConfirmation(false);

    return {
        confirmation, confirmated,notConfirmated
    }
}